module.exports = __webpack_public_path__ + "static/title-29c7d0e6e1a385c62b65d195397c6979.png";